import { CONSTANTS } from "./callcentral.constants";

export const emsMenuConstants = [
  {
    menuId: 1,
    menuName: "Start A Case",
    menuIcon: "icon-site",
    menuCode: "start-a-case",
    isMenuSelected: false,
    link: "/client/emt-home",
    disabled: false,
  },
  {
    menuId: 99,
    menuName: "Settings",
    menuIcon: "icon-settings",
    menuCode: "Settings",
    isMenuSelected: false,
    link: "/client/menu-settings",
    disabled: false,
  },
];

export const statusBoardMenuConstants = [
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.HOME,
    menuName: "Home",
    menuIcon: "icon-home",
    menuCode: "HOME",
    isMenuSelected: false,
    link: "/client/home",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.CALL_SCHEDULE,
    menuName: "Schedule",
    menuIcon: "icon-my_schedule",
    menuCode: "Call Schedule",
    isMenuSelected: false,
    link: "/client/call-schedule",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.MESSAGES,
    menuName: "Messages",
    menuIcon: "icon-chat_bubble",
    menuCode: "Chat",
    isMenuSelected: false,
    link: "/client/messages",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.MY_PATIENTS,
    menuName: "My Patients",
    menuIcon: "icon-network",
    menuCode: "My Patients",
    isMenuSelected: false,
    link: "/client/my-patients",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.TEAMS,
    menuName: "Teams",
    menuIcon: "icon-team",
    menuCode: "Teams",
    isMenuSelected: false,
    link: "/client/teams",
    disabled: false,
  },
  // {
  //   menuId: CONSTANTS.MENU_LIST_ITEMS.FILE_SHARE,
  //   menuName: "Send Media",
  //   menuIcon: "icon-document",
  //   menuCode: "File Share",
  //   isMenuSelected: false,
  //   link: "/client/file-share",
  //   disabled: false,
  // },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.SITE,
    menuName: "Sites",
    menuIcon: "icon-site",
    menuCode: "Site",
    isMenuSelected: false,
    link: "/client/sites",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.NURSE_MANAGEMENT,
    menuName: "Nurse Management",
    menuIcon: "icon-nurse_management",
    menuCode: "Nurse Management",
    isMenuSelected: false,
    link: "/client/nurse-management",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.CASE_HISTORY,
    menuName: "Emergency Cases",
    menuIcon: "icon-nurse_management",
    menuCode: "Case History",
    isMenuSelected: false,
    link: "/client/case-history",
    disabled: false,
  },
];

export const menuConstants = [
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.SITE,
    menuName: "Sites",
    menuIcon: "icon-site",
    menuCode: "Site",
    isMenuSelected: false,
    link: "/client/sites",
    disabled: false,
  },

  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.TEAMS,
    menuName: "Teams",
    menuIcon: "icon-team",
    menuCode: "Teams",
    isMenuSelected: false,
    link: "/client/teams",
    disabled: false,
  },

  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.MY_PATIENTS,
    menuName: "My Patients",
    menuIcon: "icon-network",
    menuCode: "My Patients",
    isMenuSelected: false,
    link: "/client/my-patients",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.UNASSIGNED_SHIFT,
    menuName: "Unassigned Shifts",
    menuIcon: "icon-unassigned_shift",
    menuCode: "Unassigned-shifts",
    isMenuSelected: false,
    link: "/client/unassigned-shift",
    disabled: false,
  },

  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.NURSE_MANAGEMENT,
    menuName: "Nurse Management",
    menuIcon: "icon-nurse_management",
    menuCode: "Nurse Management",
    isMenuSelected: false,
    link: "/client/nurse-management",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.CASE_HISTORY,
    menuName: "Emergency Cases",
    menuIcon: "icon-nurse_management",
    menuCode: "Case History",
    isMenuSelected: false,
    link: "/client/case-history",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.STATUS_BOARD,
    menuName: "Status Board",
    menuIcon: "icon-status_board",
    menuCode: "Status Board",
    isMenuSelected: false,
    disabled: false,
    statusBoardSubList: [],
  },
];

export const ccPlusmenuConstants = [
  // {
  //   menuId: CONSTANTS.MENU_LIST_ITEMS.FILE_SHARE,
  //   menuName: "Send Media",
  //   menuIcon: "icon-document",
  //   menuCode: "File Share",
  //   isMenuSelected: false,
  //   link: "/client/file-share",
  //   disabled: false,
  // },
];

export const BasicmenuConstants = [
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.HOME,
    menuName: "Home",
    menuIcon: "icon-home",
    menuCode: "HOME",
    isMenuSelected: false,
    link: "/client/home",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.CALL_SCHEDULE,
    menuName: "Schedule",
    menuIcon: "icon-my_schedule",
    menuCode: "Call Schedule",
    isMenuSelected: false,
    link: "/client/call-schedule",
    disabled: false,
  },
  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.MESSAGES,
    menuName: "Messages",
    menuIcon: "icon-chat_bubble",
    menuCode: "Chat",
    isMenuSelected: false,
    link: "/client/messages",
    disabled: false,
  },
  {
    menuId: 99,
    menuName: "Settings",
    menuIcon: "icon-settings",
    menuCode: "Settings",
    isMenuSelected: false,
    link: "/client/menu-settings",
    disabled: false,
  },
];

export const footerMenuConstants = [
  {
    menuId: CONSTANTS.FOOTER_MENU_LIST_ITEMS.SITE,
    menuName: "Site",
    menuIcon: "icon-site",
    menuCode: "Site",
    isMenuSelected: false,
    link: "/client/sites",
    disabled: false,
  },

  {
    menuId: CONSTANTS.FOOTER_MENU_LIST_ITEMS.MY_PATIENTS,
    menuName: "My Patients",
    menuIcon: "icon-network",
    menuCode: "My Patients",
    isMenuSelected: false,
    link: "/client/my-patients",
    disabled: false,
  },

  {
    menuId: CONSTANTS.MENU_LIST_ITEMS.TEAMS,
    menuName: "Teams",
    menuIcon: "icon-team",
    menuCode: "Teams",
    isMenuSelected: false,
    link: "/client/teams",
    disabled: false,
  },
];

export const basicFooterMenuConstants = [
  {
    menuId: CONSTANTS.FOOTER_MENU_LIST_ITEMS.ONCALL_LOOK_UP,
    menuName: "Lookup",
    menuIcon: "icon-oncall_lookup",
    menuCode: "On Call Lookup",
    isMenuSelected: false,
    link: "/client/oncalllookup",
    disabled: false,
  },
  {
    menuId: CONSTANTS.FOOTER_MENU_LIST_ITEMS.CALL_SCHEDULE,
    menuName: "Schedule",
    menuIcon: "icon-my_schedule",
    menuCode: "Call Schedule",
    isMenuSelected: false,
    link: "/client/call-schedule",
    disabled: false,
  },
  {
    menuId: CONSTANTS.FOOTER_MENU_LIST_ITEMS.HOME,
    menuName: "Home",
    menuIcon: "icon-home",
    menuCode: "HOME",
    isMenuSelected: false,
    link: "/client/home",
    disabled: false,
  },
  {
    menuId: CONSTANTS.FOOTER_MENU_LIST_ITEMS.MESSAGES,
    menuName: "Messages",
    menuIcon: "icon-chat_bubble",
    menuCode: "Chat",
    isMenuSelected: false,
    link: "/client/messages",
    disabled: false,
  },

];
